import type { ExtendedConstraints, CapabilityConfig } from '../../../types';
import * as AppletSpec from '../applet/applet';

export type Applet = AppletSpec.Applet;

export const id = 'config-applet';

export enum Events {}
export enum Actions {}

export type Config = AppletSpec.Config & {
  type: typeof id;
};

export type ConfigObject = Record<string, unknown>;

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;
}>;

export function isValidConfig(config: CapabilityConfig): boolean {
  if (!AppletSpec.isValidConfig(config)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  return true;
}
